<style lang="scss" scoped>
.font-weight {
    font-weight: 800;
}
</style>
<template>
    <div>
        <div v-if="type=='query'" class="margin-top-10 margin-bottom-10">
            <vButton class="margin-right-10 light-content" @click="alertmodal('remark')">添加备注</vButton>
            <vButton class="margin-right-10" v-if="this.formData.status == 0" theme="success" @click="alertmodal('audit')">提交审核</vButton>
            <vButton class="margin-right-10" v-if="this.formData.status == 1" theme="warning" @click="alertmodal('pass')">通过审核</vButton>
            <vButton v-if="type=='query'" class="margin-right-10" theme="primary" @click="adddocument">添加附件</vButton> 
            <vButton class="pull-right" v-if="this.formData.status == 1" @click="alertmodal('rejected')">审核驳回</vButton>
        </div>
        <compWrapper title="新品推荐" theme="primary">
            <compFormQuery
                v-if="type=='query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
                placeholder="--"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="supplierEditForm"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />
            <template v-if="type!='query'" slot="footer">
				<vButton class="margin-right-20" theme="info" @click="submit('caogao')">保存为草稿</vButton>
                <vButton class="margin-right-20" theme="primary" @click="submit">保存并提交</vButton>
				<vButton class="margin-right-20" @click="cancel">取消</vButton>
			</template>
        </compWrapper>
        <compWrapper title="附件" theme="info">
            
            <vButton v-if="type!='query'" class="margin-top-15 margin-left-15" theme="primary" @click="adddocument">添加附件</vButton> 
            <span v-if="type!='query'" class="margin-left-10 color-error">最多传5个附件，超过请压缩后再上传</span>
            
            <vTable
                class="margin-15"
				:columns="doccolumns" 
				:data="docList"
				size="small" 
				ref="tablequery"  
				border
            ></vTable>
        </compWrapper>
        <compWrapper title="关联预选产品" theme="info" v-if="type=='query'">
            <vTable
                class="margin-15"
				:columns="productcolumns" 
				:data="productlist"
				size="small" 
				ref="tablequery"  
				border
            ></vTable>
        </compWrapper>
        <!-- 操作历史 -->
        <compWrapper title="操作历史" theme="gray" v-if="type=='query'">
            <compLog :data="logList" ></compLog>
        </compWrapper>

        <vLoading size="large" transfer :loading="loading"></vLoading>

         <!-- 全局弹框 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="closemodalprops"
		>
            <component ref="cusref" :is="modalProps.component" v-bind="modalProps" v-on="modalProps.on" ></component>
            <!-- <footer slot="footer" v-show="false"></footer> -->
        </compModal>
    </div>
</template>

<script>
import { mapState,mapGetters } from "vuex";
import { HttpGetRecommendOne,HttpSaveRecommendOne,HttpCheckRecommend,HttpSubmitRecommend,HttpRemarkRecommend,HttpRecommendAndProdeve,HttpUploadRecommendAttach } from "@/service/proddevelop";
import { HttpGetCategories } from '@/service/products/allproducts'
import { HttpDelAttach, HttpDelAttachNew } from "@/service/purchase/purchase";
import { HttpSysOpLog } from '@/service/boss/allot';
// 搜索品类
import searchCategory from "../../products/searchcategory/index";
import compAlertpass from './alertpass';

import mixin from '../mixins'
export default {
    mixins: [mixin],
    props:['activeid','querytype'],
    data(){
        return {
            type: this.$route.params.type || this.querytype,
            id: this.$route.query.id || this.activeid,
            formData:{
            },
            logList:[],
            docList:[],
            productlist:[],
            categoryList:[],
            downcateoryList:[],
            modalProps:{
                show:false,
                title:"",
                component: null
            },
            loading:false,
            titleName:'',
        }
    },
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        searchCategory,
        compAlertpass,
	},
    created(){
        this.getcategory();
        
    },
    computed:{
        ...mapGetters('diction',['getNewProductList','getAllProductPerson']),
        ...mapState('boss', ['accountTypes']),
        getUserList(){
            return this.getAllProductPerson.filter(function(item){
                // console.log(item)
                return item.label != ''
            })
        },
        getFileProps(){
            return {
                data: {
                    // sourceId:this.id || 0,
                    srcLabel: this.id || 0,
                    model: 'supplier',
                    type: 'other'
                },
				action: process.env.VUE_APP_APIURL_UC + this.operate.actionurl,
                name: "multipartFile",
                multiple: true
            }
        },
        getBase(){
            return [
                {
					label: "标题",
					key: "title",
                    tag: "vInput",
                    span:24,
				},
                {
					label: "单据状态",
                    key:'status',
                    tag: "Select",
                    options:this.getRecommendStatus,
                    show:this.type=='query'
                },
                {
					label: "品类",
                    key: "categoryName",
                    children: (h) => {
						return <vIcon
							title={this.$t('erp.product.search_category',{defaultValue:'搜索品类'})}
							type="search"
							center
							slot="suffix"
							style="padding:6px;pointer-events: initial;"
							size="18"
							nativeOnClick={this.handleModalplat.bind(this)}
						/>
					},
					props: {
                        readonly: true,
                        placeholder:this.$t('erp.product.select_category',{defaultValue:'请选择品类'})
					},
                    required: false,
                    formItem: {
						tip: this.type == 'query' ? '' : '<div class="color-error">如果选不到你想要的品类，请将你的品类填入品类描述中</div>',
                    },
                    show:this.type != 'query'
                },
                {
					label: "品类",
					key: "categoryId",
                    tag: "Select",
                    options: this.downcateoryList.map(item=>{
                        return {
                            value:item.id,
                            label:item.code+'-'+item.name
                        }
                    }),
                    required: false,
                    show:this.type == 'query'
				},

                {
					label: "品类描述",
					key: "categoryDesc",
					tag: "Input",
                    required: false,
                    props:{
                        placeholder:'请填写三级品类，例Outdoor Shades/Gazebos/Gazebos',
                    },
                },
                
                // 单独品类
				{
					span:24,
					show:this.type!='query',
					valueText:this.titleName,
					query:true,
                },
                {
					span:12,
					show:this.type=='query',
					valueText:this.formData.categoryCodeName,
					query:true,
                },
                
                {
					label: "来源",
					key: "source",
					tag: "vSelect",
                    options:[
                        {value:'MP',label:'MP'},
                        {value:'BU',label:'BU'},
                        {value:'Sourcing',label:'Sourcing'},
                        {value:'Other',label:'Other'},
                    ],
					props: {
						filterable: true,
                    },
				},
                {
					label: "目标站点",
					key: "targetSite",
					tag: "Select",
                    options: this.accountTypes.map(item=>{
                        return {
							value: item.name,
							label: item.name
						}
                    }),
					props: {
                        filterable: true,
                        multiple: true
                    },
                    required: false,
                },
                {
					label: "提交时间",
                    key: "submitTime",
                    tag: "vDatepicker",
                    props: {
                        confirm:false,
                        format: "yyyy-mm-dd"
                    },
                    required: false,
                    show:this.type=='query'
                },
                {
					label: "提交人",
                    key: "submitterId",
                    tag:'Select',
                    options:this.getUserList.map(item=>{
                        return {
                            value:item.attach.id,
                            label:item.label
                        }
                    }),
                    required: false,
                    show:this.type=='query'
                },
                {
					label: "审核通过时间",
                    key: "approvedTime",
                    tag: "vDatepicker",
                    props: {
                        confirm:false,
                        format: "yyyy-mm-dd"
                    },
                    required: false,
                    show:this.type=='query'
                },
                {
					label: "审核人",
                    key: "reviewerId",
                    tag:'Select',
                    options:this.getUserList.map(item=>{
                        return {
                            value:item.attach.id,
                            label:item.label
                        }
                    }),
                    required: false,
                    show:this.type=='query'
                },
                {
					label: "竞品链接",
					key: "competitiveLink",
                    tag: "vTextarea",
                    props:{
                        placeholder:"输入多个，一行一个",
                    },
                    show:this.type!='query'
                },
                {
					label: "竞品链接",
					key: "competitiveLink",
                    tag: "div",
                    show:this.type=='query',
                    render:(h)=>{
                        let competitiveArr= (this.formData.competitiveLink || '').split(",");
                        return competitiveArr.map(item=>{
                            return <div style="word-wrap:break-word; word-break:break-all;overflow: hidden;"><a href={item} target="_blank">{item}</a></div>
                        })
                    }
                },
                {
					label: "推荐理由",
					key: "recommendReason",
					tag: "vTextarea",
                },
                {
					label: "项目",
                    key: "lineId",
                    tag: "Select",
                    options: this.getNewProductList,
					props: {
						filterable: true,
                    },
                    on:{
                        'on-change':(val)=>{
                            let oneLine = this.getNewProductList.filter(item=>{return val === item.value})[0]
                            this.formData.department = oneLine.attach.nickname;
                        }
                    },
                    required: false,
                },
                {
					label: "所属部门",
                    key: "department",
                    tag: "Input",
                    required: false,
                },
                {
					label: "推荐类型",
                    key: "recommendType",
                    tag: "Select",
                    options: [
                        {value:0,label:'纯新品'},
                        {value:1,label:'老品拓展'},
                    ],
					props: {
						filterable: true,
                    },
                },
                {
					label: "备注",
					key: "remark",
                    tag: "vTextarea",
                    required:false,
                },
                {
					label: "取消原因",
					key: "cancelReason",
                    tag: "vTextarea",
                    required:false,
                    show:this.formData.status == 4
                },
            ]
        },
        doccolumns(){
            // let array = 
            let _this = this
            return [
				{
					title: '附件名称',
                    key: 'attachTitle',
                    render:(h,{row})=>{
                        return <a href={row.attachUrl} target="_blank">{row.attachTitle}</a>
                    }
                }, 
                {
					title: '操作时间',
                    key: 'attachOpAt'
                },
                {
					title: '操作人',
                    key: 'createdName'
                },
				{
					title: '操作',
					// width: 140,
					render(h, { row, index }) {
                        let delButton = ''
                        if (_this.type !== 'query') {
                            delButton = h('vButton', {
                                props: {
                                    theme: "error",
                                    size: 'small',
                                },
                                on: {
                                    click: () => {
                                        _this.remove(index)
                                    }
                                },
                                style: {
                                    'margin-right': '15px'
                                }
                            }, '删除')
                        }
						return h('div', [
							delButton,
                            h('vButton', {
                                props: {
                                    theme: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        _this.downfile(row.attachUrl)
                                    }
                                }
                            }, '下载')
                        ])
					}
				}
			]
        },
        productcolumns(){
            return [
                {
					title: '预编码',
					key: 'precoding',
                }, 
                {
					title: '预选产品状态',
                    // key: 'attachUrl'
                    render: (h, { row }) => this.findRenderLabel(this.getPrimaryStatus, row.status),
                },
            ]
        }
    },
    methods:{
        closemodalprops(){
            this.$emit('on-openCloseable');
            this.modalProps = {};
        },
        getcategory(){
            HttpGetCategories().then(res=>{
                this.categoryList = res.data;
                this.downcateoryList = res.data.filter(item=>{
                    return item.level == 3
                })
                this.update(); 
            })
        },
        downfile(url){
            this.handleWebfs(url, {}, 'download')
        },
        adddocument(){
            this.modalProps = {
                show: true,
                title: '添加附件',
                width: 460,
                component: "compMutiUpload",
                data: {
                    srcLabel: this.id || 0,
                    model: 'pd_recommend',
                    type: 'other',
                },
                showFooter: false,
                action: process.env.VUE_APP_APIURL_UC + '/api/v1/BizAttach/uploadFile',
                name: "multipartFile",
                multiple: true,
                beforeUpload: (fileList) => {
                    // console.log(23234344657)
                    if (fileList.length > 5) {
                        this.$VMessage.error('附件数量过多，请打包后上传');
                        return false;
                    }
                    else {
                        return true;
                    }
                },
                on:{
                    'on-success':(res)=>{
                        res.items.map((item) => {
                            this.docList.push(item);
                        })
                        if(this.type == 'query'){
                            this.succesUpload()
                        }
                        this.modalProps={}
                    },
                    'on-cancel':()=>{
                        this.modalProps={}
                    }
                },
			};
        },
        succesUpload(){
            HttpUploadRecommendAttach({
                id: this.id || 0,
                attach: JSON.stringify({
                    items: this.docList,
                    opAt: this.docList[0] ? this.docList[0].attachOpAt : '',
                    organizationId: global.SYSID
                }),
            }).then(res => {
                this.$VMessage.success(res.message)
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        aaasuccess(res) {
            // console.log(res,'rederedered')
            let flag = false
            if ((res.items.length + this.docList.length) > 5) {
                this.$VMessage.error('附件数量过多，请打包后上传')
                flag = true
            }
            res.items.map((item) => {
                if (flag) {
                    this.remove(item.attachId, true)
                }
                else {
                    this.docList.push(item)
                }
            })
            this.cancelUpload()
        },
        remove (index, useId) {
            // 新增时删除附件用另外的接口
            if (this.type === 'add') {
                HttpDelAttachNew({
                    id: useId ? index : this.docList[index].attachId
                }).then(res => {
                    if (!useId) {   
                        this.docList.splice(index, 1)
                        this.$VMessage.success(res.message)
                    }
                }, err => {
                    if (!useId) {
                        this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                    }
                })
            }
            // 编辑
            else {
                this.docList.splice(index, 1)
                HttpUploadRecommendAttach({
                    id: this.id || 0,
                    attach: JSON.stringify({
                        items: this.docList,
                        opAt: this.docList[0] ? this.docList[0].attachOpAt : '',
                        organizationId: global.SYSID
                    }),
                }).then(res => {
                    this.$VMessage.success(res.message)
                }, err => {
                    this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                })
            }
        },
        cancelUpload() {
			this.operate.show = false
        },
        getCustomer(id){
            let json = this.getAllCustomerList.filter(item=>{
                return item.value == id
            })[0] || {}
            return json.label || ''
        },
        handleModalplat(){
            this.modalProps = {
                title:'搜索品类',
                show:true,
                width:650,
                component: "searchCategory",
                showFooter:false,
                on:{
                    'on-chosedata':(data)=>{
                        console.log(data)
                        this.$set(this.formData,'categoryName',data.code+'-'+data.name);
                        this.$set(this.formData,'categoryId',data.id);

                        // 品类获取
                        let array = this.getParentItem(data.id);
                        let newarr = []
                        console.log(array)
                        for(var i = array.length-1;i>=0;i--){
                            newarr.push(array[i])
                        }
                        let title = newarr[1].name + "/" + newarr[2].name + "/" + newarr[3].name;
                        // console.log(title,'545454')
                        this.$set(this.$data,'titleName',title);
                        this.modalProps = {}
                    },
                    'on-update':()=>{
                        this.$emit('on-update');
                        this.update();
                        this.modalProps.show = false;
                    }
                }
            }
        },
        getParentItem(parentId,result=[]){
			let parent = this.categoryList.find(val=> val.id == parentId)
			if(parent){
				result.push(parent)
			}
			if(parent && parent.parentId){
				this.getParentItem(parent.parentId,result)
			}
			return result

		},
        alertmodal(type){
            switch(type){
                case 'remark':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show: true,
                        alert: "primary",
                        title: "添加备注",
                        width: 460,
                        showDesc:false,
                        params:{id:this.id},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注原因",
                            }
                        ],
                        ajaxRequest:HttpRemarkRecommend,
                        callback:()=>{
                            this.modalProps.show = false;
                            this.update()
                        }
                    };
                break;
                case 'audit':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show: true,
                        alert: "error",
                        title: "提交审核",
                        width: 460,
                        showDesc:false,
                        params:{ids:this.id},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注",
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpSubmitRecommend,
                        callback:()=>{
                            this.modalProps.show = false;
                            this.update()
                        }
                    };
                break;
                case 'pass':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show: true,
                        alert: "warning",
                        title:'通过审核',
                        width: 460,
                        component: "compAlertpass",
                        orderid:this.id,
                        categoryid:this.formData.categoryId,
                        categoryone:this.formData.categoryName,
                        showFooter:false,
                        on:{
                            'on-update':()=>{
                                this.modalProps.show = false;
                                this.update()
                            },
                            'on-close':()=>{
                                this.closemodalprops()
                            }
                        },
                    };
                break;
                case 'rejected':
                    this.$emit('on-closeCloseable');
                    this.modalProps = {
                        show: true,
                        alert: "error",
                        title: "审核驳回",
                        width: 460,
                        showDesc:false,
                        params:{statusId:3,ids:this.id},
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注",
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpCheckRecommend,
                        callback:()=>{
                            this.modalProps.show = false;
                            this.update()
                        }
                    };
                break;
            }
        },
        update(){
            if(this.type == 'add') return
            // 日志
            if(this.type == 'query'){
                HttpSysOpLog({
                    'search[EQ_opData]':this.id,
                    'search[EQ_opModel]':'Product_Development_Recommend',
                    row:1000,
                    page:1,
                }).then(res=>{
                    this.logList = res.data.content
                },err=>{
                    this.errorMessage(err.message);
                })
                HttpRecommendAndProdeve({
                    recommendId:this.id,
                }).then(res=>{
                    this.productlist = res.data
                },err=>{
                    this.errorMessage(err.message);
                })
            }
            this.loading = true;
            HttpGetRecommendOne({
                id:this.id
            }).then(res=>{
                this.formData = res.data;
                this.formData.targetSite = res.data.targetSite.split(',');
                this.docList = res.data.attachMeta ? JSON.parse(res.data.attachMeta).items : [];
                this.titleName = res.data.categoryCodeName;
                let cateone = this.downcateoryList.filter(item=>{
                    if(item.level==3){
                    
                        return item.id == res.data.categoryId;
                    }
                })[0] || {};
                
                this.$set(this.formData,'categoryName',cateone.code ? cateone.code+'-'+cateone.name : '');
                this.loading = false;
            },err=>{
                this.errorMessage(err.message);
                this.loading = false;
            })
        },
        async submit(typesta){
            let flag = false
            await this.$refs.supplierEditForm.validate(valid => {
                if (!valid) return flag = true
            })
            if (flag) return this.$VMessage.error('请填写必填项');

            if(this.formData.competitiveLink!=''){
                if(!(this.formData.competitiveLink instanceof Array)){
                    this.formData.competitiveLink = this.formData.competitiveLink.replace(/\n/g,",");
                }
            }
            let arrayLink = this.formData.competitiveLink.split(",");
            let titleLine = /http[s]{0,1}:\/\/([\w.]+\/?)\S*/;
            let falgLink = false;
            arrayLink.map(item=>{
                if(titleLine.test(item)===false){
                    falgLink = true;
                }
            })

            if(falgLink){
                this.$VMessage.error('竞品链接输入请以http/https开头');
                return;
            }


            // 判断品类和品类推荐填写其一
            if(!this.formData.categoryId && !this.formData.categoryDesc){
                this.$VMessage.error('品类或品类描述必填其一');
                return;
            }
            let onestatus = typesta == 'caogao' ? 0 : 1
            
            this.loading = true;

            HttpSaveRecommendOne({
                orgId:global.SYSID,
                ...this.formData,
                categoryCodeName:this.titleName,
                targetSite: (this.formData.targetSite || []).join(',') || '',
                status:onestatus,
                attachMeta: JSON.stringify({
                    items: this.docList,
                    opAt: this.docList[0] ? this.docList[0].attachOpAt : '',
                    organizationId: global.SYSID
                }),
                }).then(res=>{
                this.$Message.success(res.message);
                this.cancel()
                this.loading = false;
            },err=>{
                this.errorMessage(err.message);
                this.loading = false;
            })
        },
        
        cancel(){
            this.$router.push({
                name: 'recommendList',
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.other-form {
    .form-item {
        height: 42px;
        margin-bottom: 5px;
        clear: both;
    }
}
</style>

